// scv-cart-hook.js — drawer mode + global ATC interceptor + Ships reconciler.
// Extracted verbatim from sections/cart-set-view-next.liquid (the section hit
// Shopify's 256KB source cap). Loaded synchronously right where the inline
// script sat; the two config URLs arrive via window.__scvCfgUrls (set inline
// just before this file loads).
  // ── Drawer mode (now default for all traffic) ──
  // Always active. ?slideout=0 is preserved as an emergency disable flag — sets
  // sessionStorage.em_slideout='0' which bails out of drawer mode for that session.
  (function(){
    try {
      var qs = location.search || '';
      if (/[?&]slideout=0\b/.test(qs)) sessionStorage.em_slideout = '0';
      else if (/[?&]slideout=1\b/.test(qs)) sessionStorage.removeItem('em_slideout');
    } catch (e) {}
    var disabled = false;
    try { disabled = sessionStorage.em_slideout === '0'; } catch (e) {}
    if (disabled) return;

    var root = document.documentElement;
    root.classList.add('scv-mode-drawer');

    var p = location.pathname || '';
    var onCart = p === '/cart' || p.indexOf('/cart/') === 0;

    // ── Suppress Dawn's cart-drawer / cart-notification ──
    // Dawn's product-form opens its own drawer after PDP ATC. Force-hide both;
    // we capture the /cart/add.js network call below to open OUR drawer instead.
    if (!document.getElementById('scv-suppress-dawn')) {
      var hide = document.createElement('style');
      hide.id = 'scv-suppress-dawn';
      hide.textContent = 'cart-drawer, cart-notification { visibility: hidden !important; opacity: 0 !important; pointer-events: none !important; }';
      (document.head || document.documentElement).appendChild(hide);
    }

    // ── Global ATC interceptor ──
    // Catches every /cart/add.js (Dawn PDP, our stage-set, third-party apps) and
    // opens the drawer on success. Idempotent — running twice is harmless.
    //
    // POST-ADD PREORDER ENRICHMENT (Fix A, added after orders #352924 / #352914):
    // Several ATC paths bypass the packprice handler that attaches
    // `properties.Ships` — Buy It Now, dynamic checkout buttons, Dawn's bare
    // product form, third-party apps. Result: orders ship without the preorder
    // note. After each successful /cart/add.js, we read the cart and PATCH any
    // line missing Ships whose SKU is in preorder-config (and isn't a
    // continue-selling override). Misses *off-storefront* sales channels
    // (Shop app, Google/Meta channels) — those need a server-side Shopify
    // Function (Fix B). See diagnosis notes against order #352914.
    if (!window.__scvFetchHooked) {
      window.__scvFetchHooked = true;
      var origFetch = window.fetch;

      // Eager-load preorder + continue-selling configs so they're ready by the
      // time the customer adds something. Uses origFetch to avoid recursion.
      if (!window.__scvPreorderConfig) {
        window.__scvPreorderConfig = null;
        // TRUE only once a config has GENUINELY loaded. The failure path below
        // also parks [] on __scvPreorderConfig, so the value alone cannot tell
        // "no pre-orders exist" from "the fetch died" — and the stale-note
        // stripper must never act on the second.
        window.__scvPreorderCfgLoaded = false;
        window.__scvContinueSellSkus = new Set();
        // Resilient JSON fetch: the absolute CDN asset URL can transiently fail
        // (hash mid-propagation after an asset upload, CDN blip) — and a single
        // failure here used to silence preorder notes for the whole session.
        // Retry, then fall back to the same-origin path (proxied in theme dev,
        // valid on the storefront domain too).
        function __scvFetchJsonWithRetry(url, attempt) {
          attempt = attempt || 0;
          var tryUrl = url;
          if (attempt === 2) {
            var p = String(url).replace(/^https?:/, '').replace(/^\/\/[^/]+/, '');
            if (p && p.charAt(0) === '/') tryUrl = p;
          }
          return origFetch.call(window, tryUrl, { credentials: 'same-origin' })
            .then(function(r){ if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
            .catch(function(e){
              if (attempt >= 2) throw e;
              return new Promise(function(res){ setTimeout(res, 1200 * (attempt + 1)); })
                .then(function(){ return __scvFetchJsonWithRetry(url, attempt + 1); });
            });
        }
        function __scvLoadPreorderCfg(finalAttempt) {
          return __scvFetchJsonWithRetry(window.__scvCfgUrls.preorder)
            .then(function(d){
              window.__scvPreorderConfig = Array.isArray(d) ? d : [];
              window.__scvPreorderCfgLoaded = true;
              // A post-add reconcile that fired BEFORE this config landed bailed
              // silently (cfg null, no retry) — run one now that we can act.
              try { __scvEnrichPreorderProps(); } catch(e) {}
            })
            .catch(function(){
              if (finalAttempt) { window.__scvPreorderConfig = []; return; }
              // One last late attempt — a fresh asset hash can take several
              // seconds to propagate right after an upload.
              setTimeout(function(){ __scvLoadPreorderCfg(true); }, 8000);
            });
        }
        __scvLoadPreorderCfg(false);
        __scvFetchJsonWithRetry(window.__scvCfgUrls.continueSelling)
          .then(function(d){
            var arr = (d && Array.isArray(d.skus)) ? d.skus : [];
            window.__scvContinueSellSkus = new Set(arr.filter(Boolean));
          })
          .catch(function(){});
      }

      // Live truth: sku -> in-stock-now from the global pack catalog
      // (pack-catalog.liquid renders qty/avail per variant on every page).
      // Returns true/false, or null when the sku isn't in the catalog (unknown).
      function __scvSkuInStock(sku) {
        try {
          var cat = window.__emPackCatalog;
          if (!cat || !cat.products) return null;
          for (var i = 0; i < cat.products.length; i++) {
            var vs = cat.products[i].variants || [];
            for (var j = 0; j < vs.length; j++) {
              if ((vs[j].sku || '') === sku) return (vs[j].qty || 0) > 0;
            }
          }
        } catch(e) {}
        return null;
      }
      // Shared with the section's render (per-line + under-checkout notes).
      window.__scvSkuInStock = __scvSkuInStock;

      // Reconcile every line's Ships note with the CURRENT truth (both directions):
      //   should have a note  = sku in preorder-config AND NOT in stock now
      //   restocked config sku with a stale note -> note REMOVED
      //   unknown stock (sku not in catalog)     -> leave the line alone
      //   sku not in config at all               -> any Ships note REMOVED
      // Acts only once a config has genuinely loaded. Sequential PATCHes —
      // Shopify's cart API doesn't tolerate concurrent mutations on one session.
      function __scvEnrichPreorderProps() {
        var cfg = window.__scvPreorderConfig;
        if (!cfg) return;
        var skipSkus = window.__scvContinueSellSkus || new Set();
        origFetch.call(window, '/cart.js', { credentials: 'same-origin' })
          .then(function(r){ return r.ok ? r.json() : null; })
          .then(function(cart){
            if (!cart || !cart.items) return;
            var queue = [];
            for (var i = 0; i < cart.items.length; i++) {
              var it = cart.items[i];
              var props = it.properties || {};
              var current = props.Ships || props.ships || null;
              var sku = it.sku || '';
              var entry = null;
              for (var j = 0; j < cfg.length; j++) {
                if (sku && cfg[j] && cfg[j].sku === sku) { entry = cfg[j]; break; }
              }
              var expected = null;
              if (entry) {
                var inStock = __scvSkuInStock(sku);
                if (!skipSkus.has(sku) && inStock === false) {
                  expected = String(entry.note || 'Made to order').slice(0, 255);
                }
                if (inStock === null && current) continue; // unknown truth — don't strip
              } else {
                // Not a config sku -> no pre-order for it, whatever its stock.
                // The theme is the ONLY writer of `Ships`, so a note the CURRENT
                // config doesn't account for is ours and stale — strip it
                // whatever the text. The old rule recognised only notes matching
                // the config VERBATIM, so emptying the config orphaned every
                // note already sitting in a cart; carts outlive the config,
                // renewing for as long as the shopper keeps visiting (order
                // #357815 carried a 17-day-old note to checkout). Gated on a
                // CONFIRMED load so a dead fetch can never strip a live promise.
                if (!current) continue;
                if (!window.__scvPreorderCfgLoaded) continue;
              }
              if (expected === current) continue;
              if (!expected && !current) continue;
              var merged = {};
              Object.keys(props).forEach(function(k){
                if (k === 'Ships' || k === 'ships') return;
                merged[k] = props[k];
              });
              // Shopify's change.js IGNORES an empty properties object, so a line
              // whose ONLY property is a stale Ships can never be cleared by
              // omission — overwrite with '' instead (falsy for every renderer;
              // blank-valued properties are hidden at checkout).
              merged.Ships = expected || '';
              // PATCH by line KEY, never by index — concurrent cart mutations
              // (e.g. the Mum Club auto-add) shift indices and would stamp the
              // wrong line; keys are stable for the life of the line.
              queue.push({ id: it.key, quantity: it.quantity, properties: merged });
            }
            if (!queue.length) return;
            var p = Promise.resolve();
            queue.forEach(function(payload){
              p = p.then(function(){
                return origFetch.call(window, '/cart/change.js', {
                  method: 'POST', credentials: 'same-origin',
                  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                  body: JSON.stringify(payload)
                }).then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; });
              });
            });
            p.then(function(){
              if (typeof window.__scvBustCartCache === 'function') window.__scvBustCartCache();
              window.dispatchEvent(new CustomEvent('em:cart:changed'));
            });
          })
          .catch(function(){});
      }

      // Boot reconcile: carts opened with lines added under OLD rules (e.g. a
      // stale PRE-ORDER note on a long-since-restocked SKU) get corrected on
      // page load, not just after the next add. Delayed so the eager config
      // fetches above and the server-rendered pack catalog are in.
      setTimeout(__scvEnrichPreorderProps, 2500);

      window.fetch = function(input, init) {
        var prom = origFetch.apply(this, arguments);
        try {
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          var isAdd = /\/cart\/add(\.js|\.json)?(\?|$)/.test(url);
          var isMutation = /\/cart\/(add|change|clear|update)(\.js|\.json)?(\?|$)/.test(url);
          if (isMutation) {
            prom.then(function(r) {
              if (!(r && r.ok)) return;
              // Bust cart cache so the next render fetches fresh state.
              if (typeof window.__scvBustCartCache === 'function') window.__scvBustCartCache();
              if (isAdd) {
                window.dispatchEvent(new CustomEvent('scv:open'));
                // Post-add: catch any preorder line missing the Ships property.
                __scvEnrichPreorderProps();
              }
              // Generic event: any successful cart mutation. Drives the
              // progress pill + header bubble.
              window.dispatchEvent(new CustomEvent('em:cart:changed'));
            }).catch(function(){});
          }
        } catch(e) {}
        return prom;
      };
    }

    // ── PDP form-submit interceptor ──
    if (!window.__scvFormHooked) {
      window.__scvFormHooked = true;
      document.addEventListener('submit', function(ev){
        var form = ev.target;
        if (!form || form.tagName !== 'FORM') return;
        var action = form.getAttribute('action') || '';
        // Only intercept ATC forms (action ends with /cart/add). Skip the cart page form.
        if (!/\/cart\/add(\?|$|\/)/.test(action)) return;
        ev.preventDefault();
        ev.stopImmediatePropagation();
        var btn = form.querySelector('[type=submit]');
        if (btn) { btn.setAttribute('aria-disabled','true'); btn.classList.add('loading'); }
        var fd = new FormData(form);
        fetch(action, { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' } })
          .then(function(r){ return r.json().then(function(j){ return { ok: r.ok, body: j }; }); })
          .then(function(o){
            if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); }
            if (o.ok) {
              // scv:open is handled centrally by the fetch hook (this
              // request goes through the wrapped window.fetch), which
              // applies the 0→1 suppression. Don't double-dispatch here.
            } else {
              var msg = (o.body && (o.body.description || o.body.message)) || 'Could not add to cart';
              alert(msg);
            }
          })
          .catch(function(e){
            if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); }
            console.error('[scv ATC]', e);
          });
      }, true);
    }

    function attach(){
      if (document.querySelector('.scv-scrim')) return;
      var scrim = document.createElement('div');
      scrim.className = 'scv-scrim';
      document.body.appendChild(scrim);

      // Auto-open only on /cart (the cart IS the page). On other pages the drawer
      // stays closed until scv:open fires (e.g. cart-icon click or ATC).
      if (onCart) {
        requestAnimationFrame(function(){
          requestAnimationFrame(function(){ root.classList.add('scv-open'); });
        });
      }

      // Capture-phase listener on X: animate out, then navigate (on /cart) or just close (off /cart).
      var btn = document.getElementById('scv-close-btn');
      function closeDrawer(){
        if (typeof window.__scvEmit === 'function') window.__scvEmit('wardrobe_cart_closed', { close_reason: 'drawer_close' });
        root.classList.remove('scv-open');
        setTimeout(function(){
          if (onCart) {
            try {
              var ref = document.referrer || '';
              if (ref && new URL(ref).origin === location.origin) { window.history.back(); return; }
            } catch(e) {}
            window.location.href = '/';
          }
          // Off /cart: drawer stays in DOM (keep scv-mode-drawer class so reopen is fast),
          // just remove scv-open. Next scv:open re-runs the open animation.
        }, 280);
      }
      if (btn) {
        btn.addEventListener('click', function(ev){
          if (!root.classList.contains('scv-mode-drawer')) return;
          ev.preventDefault();
          ev.stopImmediatePropagation();
          closeDrawer();
        }, true);
      }
      scrim.addEventListener('click', closeDrawer);
      // Esc key parity with pack-builder slideout.
      window.addEventListener('keydown', function(e){
        if (e.key === 'Escape' && root.classList.contains('scv-open')) closeDrawer();
      });

      // Cart-icon interceptor: any click on a /cart link opens drawer instead of navigating.
      // Active only when slideout flag is set (which is implied — we wouldn't be here otherwise).
      document.addEventListener('click', function(ev){
        var a = ev.target && ev.target.closest && ev.target.closest('a[href]');
        if (!a) return;
        var h = a.getAttribute('href') || '';
        // Match /cart, /cart?…, /cart#… but NOT /cart/checkout, /cart/clear, /cart/add etc.
        if (h !== '/cart' && !/^\/cart[?#]/.test(h)) return;
        ev.preventDefault();
        window.dispatchEvent(new CustomEvent('scv:open'));
      });

      // Public open/close API + event bridge
      window.SCV = window.SCV || {};
      window.SCV.open = function(){
        if (!document.querySelector('.scv-scrim')) attach();
        if (typeof window.__scvLoadAndRender === 'function') window.__scvLoadAndRender();
        if (typeof window.__scvEmit === 'function') window.__scvEmit('wardrobe_cart_opened', { open_reason: 'scv_open' });
        requestAnimationFrame(function(){
          requestAnimationFrame(function(){ root.classList.add('scv-open'); });
        });
        // Fallback: if drawer still shows loading after 4s, force a fresh loadAndRender
        setTimeout(function(){
          if (window.__scvRenderedOk) return;
          if (typeof window.__scvLoadAndRender === 'function') window.__scvLoadAndRender();
        }, 4000);
      };
      window.SCV.close = closeDrawer;
      window.addEventListener('scv:open',  function(){ window.SCV.open();  });
      window.addEventListener('scv:close', function(){ window.SCV.close(); });
    }

    if (document.body) attach();
    else document.addEventListener('DOMContentLoaded', attach, { once: true });
  })();
